<template>
	<div v-loading="loading" class="tabExport">
		<div>
			<el-select v-model="userSelected" filterable placeholder="Choisir le technicien" clearable>
				<el-option v-for="item in users" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
            <el-date-picker
                v-model="dateSelected"
                type="daterange"
                range-separator="à"
                start-placeholder="Date de début"
                end-placeholder="Date de fin">
            </el-date-picker>
			<el-button @click.native.prevent="generateExtractFile(userSelected,dateSelected)" type="warning" size="small" class="btnGenerateCsv">
				<i class="fas fa-file-pdf iconOperationCsv"> Générer l'extraction d'heure</i>
			</el-button>
		</div>
	</div>
</template>

<script>
var moment = require('moment');
import script from '../../../../script/script.js';
import scriptExtractTime from '../../../../script/script_extract_time.js';
export default {
	data () {
		return {
			dateSelected:'',
			dataExport:[],
			dataExportPc:[],
			currentPage: 1,
			dataExportLength:null,
			loading:false,
            users:[],
			userSelected:''
		}
	},
	methods: {
		getUsers : scriptExtractTime.getUsers,
		generatePdf : scriptExtractTime.generatePdf,
		async generateExtractFile(user,date){
			this.loading = true
			await this.generatePdf(user,date)
			this.loading = false
		},
		getStartDateWeek(i){
			let startDate = null
			let j = 1
			var find = false
			while (!find) {
				if(moment().subtract(i,'w').week() != moment().subtract(i,'w').subtract(j,'d').week()){
					startDate = moment().subtract(i,'w').subtract(j-1,'d').startOf('day')
					find=true
				}else{
					j++
				}
			}
			return startDate
		},
		getEndDateWeek(i){
			let endDate = null
			let k = 1
			var find = false
			while (!find){
				if(moment().subtract(i,'w').week() != moment().subtract(i,'w').add(k,'d').week()){
					endDate = moment().subtract(i,'w').add(k-1,'d').startOf('day')
					find=true
				}else{
					k++
				}
			}
			return endDate
		},
		getDateTime(tms){
			var date = moment.unix(tms)
			return date.format('DD/MM/YYYY à HH:mm:ss')
		},
    },
	computed:{
	},
	mounted: function(){
		this.getUsers()
	}
}
</script>

<style>
.iconOperationDownload{
	font-size: 1.5em;
	color: green;
}

.iconOperationCsv{
	font-size: 1.5em;
}

.iconOperationDelete{
	font-size: 1.5em;
	color: red;
}

.tabExport{
	display: flex;
    flex-direction: column;
    justify-content: center;
    width: 75%;
    align-items: center;
	margin: auto;
	padding-top: 1em;
}

.btnGenerateCsv{
	margin-left: .5em;
}
</style>